import { createContext, useContext } from "react";

export type BusinessOnboardingHostApi = {
  openOnboarding: (options?: { freshForAdmin?: boolean }) => void;
  closeOnboarding: () => void;
  canOpenOnboarding: boolean;
  isOnboardingOpen: boolean;
};
export const BusinessOnboardingHostContext = createContext<BusinessOnboardingHostApi | null>(null);
export function useBusinessOnboardingHost() {
  const host = useContext(BusinessOnboardingHostContext);
  if (!host) throw new Error("Business onboarding requires BusinessOnboardingHostProvider.");
  return host;
}
